import { Box, List, Text } from '@chakra-ui/react'
import { FaCheckCircle } from 'react-icons/fa'
import React from 'react'
import Image from 'next/image'
import { useTranslation } from 'react-i18next'

const AboutLeidSmartCard = () => {
  const { t } = useTranslation()
  return (
    <Box
      display="flex"
      flexDirection={{ base: 'column', lg: 'row' }}
      alignItems="center"
      gap={10}
      border="1px solid"
      borderColor="updatedLeid.lightGreen"
      borderRadius="md"
      paddingTop="20px"
      paddingBottom="20px"
      marginTop="20px"
      paddingLeft={{ base: '16px', lg: '0' }}
    >
      <Box
        width="30%"
        display="flex"
        alignItems="center"
        justifyContent="center"
        borderColor="updatedLeid.lightGreen"
        // borderRight={{ base: 'none', lg: '1px solid' }}
      >
        <Image
          src="/leid_smart/badge.svg"
          alt="Leid Smart Badge"
          width={118}
          height={120}
          style={{ marginLeft: '10px' }}
          loading="lazy"
          decoding="async"
          data-nimg="1"
        />
      </Box>
      <Box paddingRight="16px">
        <Text fontSize="sm" fontWeight="semibold" paddingBottom="10px">
          {t('howToEarnIt')}
        </Text>

        <List.Root gap="2" variant="plain" align="start" fontSize="sm">
          <List.Item lineHeight="normal" fontSize="sm" color="#294828">
            <FaCheckCircle
              color="#294828"
              size="10px"
              fontSize="10px"
              style={{ marginTop: '6px', marginRight: '4px', width: '10px', height: '10px' }}
            />
            {t('leidSmart.steps.step1')}
          </List.Item>
          <List.Item lineHeight="normal">
            <FaCheckCircle
              color="#294828"
              size="10px"
              fontSize="10px"
              style={{ marginTop: '6px', marginRight: '4px', width: '10px', height: '10px' }}
            />
            {t('leidSmart.steps.step2')}
          </List.Item>
          <List.Item lineHeight="normal">
            <FaCheckCircle
              color="#294828"
              size="10px"
              fontSize="10px"
              style={{ marginTop: '6px', marginRight: '4px', width: '10px', height: '10px' }}
            />
            {t('leidSmart.steps.step3')}
          </List.Item>
          <List.Item lineHeight="normal">
            <FaCheckCircle
              color="#294828"
              size="10px"
              fontSize="10px"
              style={{ marginTop: '6px', marginRight: '4px', width: '10px', height: '10px' }}
            />
            {t('leidSmart.steps.step4')}
          </List.Item>
        </List.Root>
      </Box>
    </Box>
  )
}

export default AboutLeidSmartCard
